import { all, fork } from 'redux-saga/effects';

import auth from './auth';
import user from './user';
import company from './company';
import menu from './menu';
import profile from './profile';
import fund from './fund';
import action from './action';
import marketing_plans from './marketing_plans';
import event from './event';

export default function* root() {
  yield all([
    fork(auth),
    fork(user),
    fork(company),
    fork(menu),
    fork(profile),
    fork(fund),
    fork(action),
    fork(marketing_plans),
    fork(event)
  ]);
}
